export default __webpack_public_path__ + "static/media/VisionBackground.e4e5386f.svg";